<template>
  <div class="row row-spacing my-3">
    <div class="col-md-12">
      <div class="d-flex align-items-end flex-wrap pricing-filter-toolbar">
        <slot name="actions" />
        <slot name="before-search" />
        <div
          v-if="showSearch"
          class="form-group mb-2 mr-3 pricing-filter-search"
          :style="{ minWidth: searchMinWidth }"
        >
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              :placeholder="searchPlaceholder"
              :value="searchTerm"
              @input="$emit('search-change', $event.target.value)"
            >
            <div class="input-group-append">
              <span class="input-group-text"><i class="fa fa-search"></i></span>
            </div>
          </div>
        </div>
        <slot name="after-search" />
        <div
          v-if="showExpiredFilter"
          class="form-group mb-2 d-flex align-items-center pricing-filter-expired"
        >
          <select
            class="form-control"
            :value="expiredFilter"
            @change="$emit('expired-filter-change', $event.target.value)"
          >
            <option value="both">Show All</option>
            <option value="false">Active</option>
            <option value="true">Expired</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showSearch: {
      type: Boolean,
      default: true,
    },
    showExpiredFilter: {
      type: Boolean,
      default: true,
    },
    searchPlaceholder: {
      type: String,
      default: "Search...",
    },
    searchTerm: {
      type: String,
      default: "",
    },
    expiredFilter: {
      type: String,
      default: "false",
    },
    searchMinWidth: {
      type: String,
      default: "320px",
    },
  },
};
</script>

<style scoped>
.pricing-filter-toolbar {
  gap: 0.75rem;
}

.pricing-filter-expired {
  white-space: nowrap;
}

.pricing-filter-expired .form-control {
  width: auto;
  min-width: 120px;
}

.pricing-filter-toolbar ::v-deep .v-select {
  width: 140px;
  flex: 0 0 140px;
}

.pricing-filter-toolbar ::v-deep .vs__dropdown-toggle {
  min-width: 140px;
}
</style>
